import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const VerticalTemplateOneOneTwo = ({
  titleText = "THE BEST PRODUCT IS HERE",
  titleFont = "Roboto",
  titleFontSize = "48",
  titleColor = "#FFFFFF",
  titleTextAlign = "center",
  titleIsBold = false,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleLetterSpacing = "-2px",

  subtitleText = "And it's yours today.",
  subtitleFont = "Roboto",
  subtitleFontSize = "28",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  backgroundType = "color",
  backgroundColor = "#3D4F46",
  backgroundImage = null,

  contentImageOne = null,
  contentImageOnePreview = null,

  buttonLabel = "Get Started",
  buttonFont = "Roboto",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "24",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#2EAC52",

  backgroundImagePreview,

  inmeeting = false,
  preview = false,
  onClose,
  position = "left",
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-full" : isMobile ? "h-full" : "!h-[89vh] mt-[30%] w-72"
      } ${
        isMobile && inmeeting
          ? position === "left" || position === "right"
            ? "" // Let it size naturally
            : "w-full" // Fill container for center/top/bottom
          : "w-72"
      } flex flex-col mx-auto overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Top Section - Title */}
      <div className="flex-1 flex items-center justify-center px-4 md:px-6">
        <h1
          className={`text-center ${
            explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
          } leading-tight`}
          style={{
            color: titleColor,
            fontSize: `${titleFontSize}px`,
            fontFamily: titleFont,
            textAlign: titleTextAlign,
            ...(titleLetterSpacing
              ? { letterSpacing: titleLetterSpacing }
              : {}),
          }}
        >
          {titleText}
        </h1>
      </div>

      {/* Middle Section - Image */}
      <div className="flex items-center justify-center bg-gray-900">
        {contentImageOne || contentImageOnePreview ? (
          <img
            src={
              contentImageOne instanceof File
                ? contentImageOnePreview
                : contentImageOne
            }
            alt="Product"
            className="w-full max-h-80 object-contain"
          />
        ) : (
          <img
            src="/image_placeholder.png"
            alt="Product"
            className="w-full object-contain"
          />
        )}
      </div>

      {/* Bottom Section - Subtitle and Button */}
      <div className="flex-1 flex flex-col items-center justify-center gap-6 px-4 md:px-6">
        <p
          className={`text-center ${
            explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: subtitleColor,
            fontSize: `${subtitleFontSize}px`,
            fontFamily: subtitleFont,
            textAlign: subtitleTextAlign,
          }}
        >
          {subtitleText}
        </p>

        <button
          className={`px-2 py-2 md:px-4 md:py-2 rounded-md transition-all duration-200 shadow-lg hover:shadow-xl ${
            explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(buttonIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""
          } ${buttonLink ? "cursor-pointer" : "cursor-default"}`}
          style={{
            backgroundColor: buttonBackgroundColor,
            color: buttonFontColor,
            fontSize: `${buttonFontSize}px`,
            fontFamily: buttonFont,
          }}
          onClick={() => {
            if (buttonLink) {
              window.open(buttonLink, "_blank");
            }
          }}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default VerticalTemplateOneOneTwo;
